import React from 'react';

import { Box } from '@zillow/constellation-10';
import { Label } from '@zillow/constellation-10';

import HeatingOil_v1 from './HeatingOil_v1';
import type { Section } from '../../../../models/index';
import { HEATING_OIL } from '../../../../constants';
import YesAndNo from '../../../Widgets/YesAndNo';
import { isMultiFamily } from '../Utilities/MultiFamilyLandlordUtility';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function HeatingOil_v2({ section, setSectionValues }: Props): JSX.Element {
  function yesDeliveredToAreas(): void {
    setSectionValues({
      [HEATING_OIL.FIELD_NAME.MULTIFAMILY_TENANT_RESPONSIBILITY.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: true,
    });
  }

  function noDeliveredToAreas(): void {
    setSectionValues({
      [HEATING_OIL.FIELD_NAME.MULTIFAMILY_TENANT_RESPONSIBILITY.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: false,
    });
  }

  return (
    <HeatingOil_v1
      section={section}
      setSectionValues={setSectionValues}
      additionalFields={{
        [HEATING_OIL.FIELD_NAME.MULTIFAMILY_TENANT_RESPONSIBILITY.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: null,
      }}
    >
      {isMultiFamily && (
        <>
          <Label>Will this heating oil service be delivered to areas other than the tenant’s unit?</Label>
          <Box css={{ marginBottom: 'layout.tighter' }} />
          <YesAndNo
            yesActive={section.getFieldValue(
              HEATING_OIL.FIELD_NAME.MULTIFAMILY_TENANT_RESPONSIBILITY.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT,
            )}
            yesHandler={yesDeliveredToAreas}
            noHandler={noDeliveredToAreas}
          />
        </>
      )}
    </HeatingOil_v1>
  );
}

HeatingOil_v2.description = 'Asks if heating oil service will be delivered to other areas';
